<template>
  <!-- <div class="loader vx-col w-1/2 md:w-1/3 xl:w-1/6 ">
    <statistics-card-line 
      hideChart
      class="mb-base"
      :icon="settings.icon" 
      :statistic="settings.value"
      :statisticTitle="settings.label"
    />
 
  </div> -->

  <div
    v-if="isMounted"
    :key="settings.icon"
    :class="settings.divClass"
  >
    <vx-card id="loader">
      <div
        class="vx-row flex-col-reverse md:flex-col-reverse sm:flex-row lg:flex-row"
      >
        <!-- LEFT COL -->
        <div
          class="vx-col w-full md:w-full sm:w-1/2 lg:w-1/2 xl:w-1/2 flex flex-col justify-between"
          v-if="salesBarSession.analyticsData"
        >
          <div>
            <h2 class="mb-1 font-bold">
              {{ settings.value.currency }}
              {{
                Number(settings.value.total).toLocaleString(undefined, {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                })
              }}
            </h2>
            <span class="font-medium">{{ settings.label }}</span>

            <!-- Previous Data Comparison -->
          </div>
          <vs-button
            v-show="settings.showViewDetails"
            icon-pack="feather"
            icon="icon-chevrons-right"
            icon-after
            class="shadow-md w-full lg:mt-0 mt-4"
            @click="gotoDetails"
            >View Details</vs-button
          >
        </div>

        <!-- RIGHT COL -->
        <div
          class="vx-col w-full md:w-full sm:w-1/2 lg:w-1/2 xl:w-1/2 flex flex-col lg:mb-0 md:mb-base sm:mb-0 mb-base"
        >
          <vs-dropdown
            vs-trigger-click
            class="cursor-pointer vs-con-dropdown parent-dropdown cursor-pointer self-end"
          >
            <small class="flex cursor-pointer">
              <span>{{ selectedFilter }}</span>
              <feather-icon
                icon="ChevronDownIcon"
                svgClasses="h-4 w-4"
                class="ml-1"
              />
            </small>
            <vs-dropdown-menu class="w-32"> 
              <vs-dropdown-item @click="getFilteredValue('Last 30 Days')"
                >Last 30 days</vs-dropdown-item
              > 
              <vs-dropdown-item @click="getFilteredValue('This Year')"
                >This Year</vs-dropdown-item
              >
              <vs-dropdown-item @click="getFilteredValue('Last Year')"
                >Last Year</vs-dropdown-item
              >
            </vs-dropdown-menu>
          </vs-dropdown>
          <vue-apex-charts
            ref="realtimeChart"
            type="bar"
            height="200"
            :options="salesBarSession.chartOptions"
            :series="barChartData"
            v-if="salesBarSession.series"
          />
        </div>
      </div>
      <vs-divider class="my-6"></vs-divider>
      <div class="vx-row">
        <div
          v-for="(val, id) in settings.value.category"
          :key="id"
          v-cloak
          class="vx-col w-1/2 mb-3"
        >
          <p>{{ val.categoryName }}:</p>
          <span>
            {{ settings.value.currency }}
            {{ Number(val.amount).toLocaleString() }}</span
          >
          <vs-progress
            class="block mt-1"
            :percent="getPercentage(val.amount)"
            :color="getRandomColor()"
          ></vs-progress>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import StatisticsCardLine from "./StatisticsCardLine.vue";
import axios from "@/axios.js";
import { axiosMixin } from "@/mixin/axiosMixin.js";
export default {
  data() {
    return {
      selectedFilter: "Last 30 Days",
      isMounted: false,
      salesBarSession: {},
      color: ["primary", "success", "warning", "danger"],
    };
  },
  mixins: [axiosMixin],
  components: {
    StatisticsCardLine,
    VueApexCharts,
  },
  props: {
    settings: Object,
    default: {},
  },
  computed: {
    barChartData() {
      return this.salesBarSession.series;
    },
  },
  methods: {
    gotoDetails(){
      //form/wo/all 
      this.$router.push(this.settings.viewDetailsPath).catch(() => {});
    },
    startLoading() {
      this.$vs.loading({
        container: "#loader",
        scale: 0.6,
      });
    },
    closeLoading() {
      this.$vs.loading.close("#loader > .con-vs-loading");
    },
    getFilteredValue(value) {
      this.selectedFilter= value;
      this.startLoading();
       var filter = {filter:value};
      if(this.settings.hasOwnProperty('clientId')){
        filter['clientId'] =  this.settings.clientId;
      }


      this.aronPost(this.settings.filterUrl, filter, "", "")
        .then((response) => {
          if (response.status == 200) {
            this.settings.value = response.data.data;
            this.salesBarSession.series[0].data = response.data.data.Yaxis;

            this.$refs.realtimeChart.updateSeries(
              [
                {
                  data: response.data.data.Yaxis,
                },
              ],
              false,
              true
            );

            this.$refs.realtimeChart.updateOptions(
              {
                xaxis: {
                  categories: response.data.data.Xaxis,
                },
              },
              false,
              true
            );
          }

          this.closeLoading();
        })
        .catch((error) => {
          // this.decodeErrorFromAxios(error);
          this.closeLoading();
        });
    },

    getRandomColor() {
      const idx = Math.floor(Math.random() * this.color.length);
      return this.color[idx];
    },
    getPercentage(amount) {
      return (amount / this.settings.value.total) * 100;
    },
  },
  created() {
    console.log("settings in activity:", this.settings);
    this.isMounted = true;

    this.salesBarSession = {
      series: [
        {
          name: "",
          data: this.settings.value.Yaxis,
        },
      ],
      analyticsData: {
        session: 2700,
        comparison: {
          str: "Last 7 Days",
          result: +5.2,
        },
      },
      chartOptions: {
        xaxis: {
          categories: this.settings.value.Xaxis,
        },
        grid: {
          show: false,
          padding: {
            left: 0,
            right: 0,
          },
        },
        chart: {
          type: "bar",
          sparkline: { enabled: true },
          toolbar: { show: false },
        },
        states: {
          hover: {
            filter: "none",
          },
        },
        colors: ["#7367f0"],
        plotOptions: {
          bar: {
            columnWidth: "45%",
            distributed: true,
            endingShape: "rounded", // Deprecated
            // borderRadius: '20px', // Coming Soon
          },
        },
        tooltip: {
          x: { show: true },
        },
      },
    };
  },
};
</script>
 